const ROLE = { NONE: 0, ASSISTANT: 1, LECTURER: 2 }

export default {
  accid: '',
  icon: '',
  name: '',
  token: '',
  onlineMemberNum: 0,
  ROLE,
  role: ROLE.NONE,
  expressionTable: {
    i001: 'i001.png',
    i002: 'i002.png',
    i003: 'i003.png',
    i004: 'i004.png',
    i005: 'i005.png',
    i006: 'i006.png',
    i007: 'i007.png',
    i008: 'i008.png',
    i013: 'i013.png',
    i014: 'i014.png',
  },
  giftTable: {
    i015: { name: '跑车', value: 'i015', src: 'i015.png', coinCost: 100, diamondCost: 0, consumeType: 1 },
    i016: { name: '游艇', value: 'i016', src: 'i016.png', coinCost: 200, diamondCost: 0, consumeType: 1 },
    i017: { name: '飞机', value: 'i017', src: 'i017.png', coinCost: 300, diamondCost: 0, consumeType: 1 },
    i018: { name: '火箭', value: 'i018', src: 'i018.png', coinCost: 0, diamondCost: 1, consumeType: 2 },
    i009: { name: '玫瑰花', value: 'i009', src: 'i009.png', coinCost: 0, diamondCost: 0, consumeType: 0 },
    i010: { name: '小心心', value: 'i010', src: 'i010.png', coinCost: 10, diamondCost: 0, consumeType: 1 },
    i011: { name: '小橙橙', value: 'i011', src: 'i011.png', coinCost: 10, diamondCost: 0, consumeType: 1 },
    i012: { name: '奖杯', value: 'i012', src: 'i012.png', coinCost: 10, diamondCost: 0, consumeType: 1 },
  },
  // 新版表情映射表
  emoticonTable: {
    '[赞]': 'i001.png',
    '[超酷]': 'i002.png',
    '[飞吻]': 'i003.png',
    '[奋斗]': 'i004.png',
    '[机智]': 'i005.png',
    '[啥]': 'i006.png',
    '[哭]': 'i007.png',
    '[愉快]': 'i008.png',
    '[迷人]': 'i013.png',
    '[开心]': 'i014.png',
  },
  broadcast: {},
  messageTips: '',
}
